import { SET_NAVBAR_TYPE } from './actions';

const INITIAL_STATE = '';

const navbarTypeReducer = (state = INITIAL_STATE, action) => (
  action.type === SET_NAVBAR_TYPE ? action.payload : state
);

export default navbarTypeReducer;
